import { render, staticRenderFns } from "./MiniProfileView.vue?vue&type=template&id=465938b3&"
import script from "./MiniProfileView.vue?vue&type=script&lang=js&"
export * from "./MiniProfileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports